import React, { Component } from 'react';

class Closed extends Component {
    render() {
        return (
            <div>
                <p>Participation Certificate orders are now closed. If you have already placed an order this year, please allow 6-10 weeks for delivery. We appreciate your patience.</p>
                {/* <p>&nbsp;</p> */}
                <p>If you have any questions, please feel free to contact us at <a href="mailto:ParticipationCertificate@recordingacademy.com" style={{color: "blue"}} target="_blank">ParticipationCertificate@recordingacademy.com</a>.</p>
            </div>
        );
    }
}

export default Closed;